<template>
  <b-card>
    <table-component
      :section="'user'"
      :detail-url="'userDetail'"
      :columns="columns"
      @switchUser="confirmSwitch"
    />
  </b-card>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import TableComponent from '@/layouts/components/TableComponent.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import { refreshMenu, periodList } from '@core/layouts/utils'
import { initialAbility } from '@/libs/acl/config'

import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    TableComponent,
    BCard,
  },
  data() {
    return {
      columns: [
        {
          label: '#',
          field: 'id',
          type: 'number',
          tdClass: 'text-center',
          thClass: 'text-center',
          width: '50px',
        },
        {
          label: '',
          field: 'switchUser',
          tdClass: 'text-center',
          thClass: 'text-center',
          width: '50px',
        },
        {
          label: 'Name',
          field: 'fullName',
        },
        {
          label: 'Email',
          field: 'email',
        },
        {
          label: 'Role',
          field: 'role',
        },
        {
          label: 'Status',
          field: 'status',
        },
      ],
    }
  },
  methods: {
    async goto() {
      // await createMenu()
      await refreshMenu()
      await periodList()
    },
    confirmSwitch(id) {
      this.$swal({
        title: this.$t('Login as different user'),
        text: this.$t('Selected user\'s session will be terminated, and you will need to login again to go back your account.'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Yes, continue!'),
        cancelButtonText: this.$t('Cancel'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.switchUser(id)
        }
      })
    },
    async switchUser(id) {
      useJwt.axiosIns.post(`user/authenticateasotheruser/${id}`)
        .then(async response => {
          // LOG OUT FROM CURRENT USER
          localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
          localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

          // Remove userData from localStorage
          localStorage.removeItem('userData')

          // Reset ability
          this.$ability.update(initialAbility)

          // USE OTHER USER DATA
          const { userData } = response.data
          useJwt.setToken(response.data.accessToken)
          useJwt.setRefreshToken(response.data.refreshToken)
          localStorage.setItem('userData', JSON.stringify(userData))
          this.$ability.update(userData.ability)

          await this.goto()
          const { menuLinks } = store.state.verticalMenu
          if (userData.role === 'superadmin' || userData.role === 'admin') {
            this.$router.push(getHomeRouteForLoggedInUser(userData.role))
          } else if (menuLinks) {
            const firstPage = menuLinks[0]

            this.$router.push({ name: 'dashboard', params: { id: firstPage.id } })
              .then(() => {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: `Welcome ${userData.fullName}`,
                    icon: 'CoffeeIcon',
                    variant: 'success',
                    text: `You have successfully logged in as ${userData.role}. Now you can start to explore!`,
                  },
                })
                window.location.reload()
              })
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
  },
}
</script>
